import { formatCurrency } from '~/utils/currencyFormatter';

export const formatPrice = (price: number | undefined, currency: string) => {
  if (price === undefined || price === null) {
    return 'N/A';
  }
  return formatCurrency(price, currency, 'en-AU');
};

export const formatMargin = (margin: number | undefined) => {
  if (margin === undefined || margin === null) {
    return 'N/A';
  }
  return `${margin.toFixed(2)}%`;
};
